module.exports = __webpack_public_path__ + "static/media/costcase5.ae739b8e.png";